import React, { useEffect, useState } from 'react';
import './Details.css';
// import { useLocation } from 'react-router-dom';
import { getDetailsdata, getRandomdata } from '../../api';
import Header from '../Home/Header/Header';
import Navlist from '../Home/Navlist/Navlist';
import Footer from '../Home/Footer/Footer';
import { insert_adv, remove_adv } from '../../method/adv'
import { iframeLoad } from '../../method/analytics';
// import {useNavigate} from 'react-router-dom';
// useNavigate useLocation useDispatch useSelector useState useEffect useMemo useCallback useImperativeHandle useParams useSearchParams


export default function Details() {
  const [navFlag, setNavflag] = useState(false);

  // const navigate = useNavigate();
  const [data, setData] = useState({});
  const [likeList, setLikeList] = useState([]);
  const [link, setLink] = useState();

  const { search } = window.location;
  const resSearch = search.substring(1);
  // console.log(resSearch);

  const getData = () => {
    getDetailsdata(resSearch).then(res => {
      // console.log(res);
      setData(res.data.data);
      setLikeList(res.data.recommend);
    })
  }

  const setNav = () => {
    navFlag ? setNavflag(false) : setNavflag(true);
  }

  /* const goDetails = (para) => {
    window.location = para;
    // navigate(para);
  } */

  // Random
  const randomBtn = async () => {
    // console.log(resSearch.split('=')[1]);
    let target = await getRandomdata().then(res => {
      // console.log(res.data.data);
      return res.data.data[Math.floor(Math.random() * res.data.data.length + 1)];
    })
    setLink(target);
  }

  /* const addIframe = () => {
    var ifr = document.createElement('iframe');
    ifr.src = "https://h.eqxiu.com/s/zAd1U265";
    document.getElementById('adv_1').appendChild(ifr);
  } */

  useEffect(() => {
    getData();
    randomBtn();

    if (window.law_ntv_ad1, window.law_ntv_ad2) {
      insert_adv("adv_1");
      insert_adv("adv_2");
      var pageLoadSecond = new Date().getTime();
      iframeLoad(pageLoadSecond);

      return () => {
        remove_adv('adv_1');
        remove_adv('adv_2');
      }
    }
  }, [])



  return (
    <div className='details'>
      <Header setNav={setNav} />
      <Navlist flag={navFlag} setNav={setNav} />

      <div className='details_con'>

        {/* details */}
        <div className='describe'>
          <h2> {data.title}</h2>

          {/* 广告一 */}
          <div className='adv_box'>
            <p>Advertisement</p>
            <div id='adv_1' dangerouslySetInnerHTML={{ __html: window.law_ntv_ad1 }}></div>
          </div>

          <div className='describe_c'>
            <p>{data.content}</p>
          </div>
        </div>

        {/* alsoLike */}
        <div className="alsoLike">

          <div className="tit">
            <h2>Related Recommend</h2>
          </div>

          <div className="alsoLike_con">

            {likeList.map(item => (
              <div className="ele" key={item.atlid}>
                <a href={item.link} className='btn_a'>
                  <h3>{item.title}</h3>
                  <p>{item.digest}</p>
                </a>
              </div>
            ))}
          </div>

        </div>

        {/* 广告一 */}
        <div className='adv_box'>
          <p>Advertisement</p>
          <div id='adv_2' dangerouslySetInnerHTML={{ __html: window.law_ntv_ad2 }}></div>
        </div>

      </div>


      <Footer />

      <div id="random">
        <a href={link} className='btn_a' style={{ color: 'white' }}>R</a>
      </div>

    </div>
  )
}
